import { useTheme } from "@/hooks/useTheme";

export function DripleeLoader({ message = "Restoring Clinical Space..." }) {
  const { theme } = useTheme();
  const isNight = theme === "night";

  return (
    <div 
      className="fixed inset-0 z-[9999] flex flex-col items-center justify-center bg-[var(--bg)] text-[#0A3D5F] dark:text-[#EBF3F8] transition-colors duration-300"
      id="driplee-loader-component"
    >
      <div className="relative w-28 h-28 mb-6 flex items-center justify-center">
        {/* Outer glowing pulsing aura */}
        <div 
          className="absolute inset-0 bg-[#2AA7A0] dark:bg-[#36CDC5] opacity-10 animate-ping rounded-full"
          style={{ animationDuration: "2.5s" }}
        />
        {/* Precision dashed slow-spinning dial */}
        <div 
          className="absolute inset-2 border-2 border-dashed border-[#2AA7A0]/25 dark:border-[#36CDC5]/20 rounded-full animate-spin"
          style={{ animationDuration: "12s" }}
        />
        {/* Subtle inner breathing ring */}
        <div 
          className="absolute inset-4 border border-[#0A3D5F]/5 dark:border-white/5 rounded-full scale-105 animate-pulse"
        />
        {/* Central brand logo */}
        <img
          src={isNight ? "/driplee-loader-dark.webp" : "/driplee-loader-light.webp"}
          alt="Driplee"
          width="80"
          height="56"
          className="relative z-10 w-20 h-auto"
        />
      </div>
      <h2 className="font-serif text-3xl font-light tracking-tight text-[#0A3D5F] dark:text-[#EBF3F8] mb-2">Driplee</h2>
      <p className="font-sans text-[10px] font-bold uppercase tracking-[0.18em] text-[#0A3D5F]/50 dark:text-[#EBF3F8]/45 animate-pulse">
        {message}
      </p>
    </div>
  );
}
